import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 940px;
`;

export const ResumeTitle = styled.p`
  color: #38393d;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 24px;
`;

export const ResumeSubtitle = styled.p`
  color: #38393d;
  font-size: 14px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputLabel = styled.p`
  color: #1a1a1a;
  font-size: 14px;
  margin-bottom: 6px;
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: solid 1px #e1e1e1;
  padding: 20px;
`;

export const MiddleContainer = styled.div`
  display: flex;
  width: 100%;
  border-bottom: solid 1px #e1e1e1;
  padding: 20px 20px 0 20px;
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 100%;
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 20px;
`;

export const ChoiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 640px;
  padding: 32px 20px;
`;

export const ChoiceOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ChoiceOptionButton = styled.button`
  cursor: pointer;
  width: 100%;
  padding: 18px 20px;
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  background-color: #ffffff;
  color: #38393d;
  font-size: 16px;
  font-weight: bold;
  text-align: left;

  :hover {
    border-color: #0073ab;
    color: #0073ab;
  }
`;

export const ContainerUploadFiles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  width: 100%;
  cursor: pointer;
`;

export const UploadIconImg = styled.img`
  width: 30px;
  height: 30px;
  margin-bottom: 5px;
`;

export const UploadText = styled.p`
  font-size: 16px;
  color: ${(props) => (props.actived ? "#2773AB" : "#38393D")};
  font-weight: bold;
`;
